import React, { useEffect, useState } from 'react';
import { Header } from './Header';
import { Autocomplete } from '@material-ui/lab';
import { Button, TextField } from '@material-ui/core';
import ApiCall from '../utils/ApiCall';
import { showErrorToast, showSuccessToast } from '../utils/toastMessage';
import tr from "date-fns/locale/tr"; // the locale you want
import subDays from "date-fns/subDays";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"

registerLocale("tr", tr); // register it with the name you want

const PassengerList = () => {
    const [stations, setStations] = useState([]);
    const [departure, setDeparture] = useState();
    const [arrival, setArrival] = useState();
    const [plate, setPlate] = useState();
    const [date, setDate] = useState(new Date());
    const [list, setList] = useState([]);
    const [detail, setDetail] = useState();
    const [rideId, setRideId] = useState();



    useEffect(() => {
        async function data() {
            setStations(await ApiCall('KKKaptan/agency/GetDuraklar', 'GET', null, true));
        }
        data();
    }, []);

    const getVoyageList = async () => {
        // if (!departure)
        //     showErrorToast("Kalkış Yeri Zorunludur")
        // else {}
        var params = {
            FromId: departure ? departure.DurakId : "",
            ToId: arrival ? arrival.DurakId : "",
            Plate: plate ? plate : "",
            'Date': date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear()
        }
        setList(await ApiCall('KKKaptan/agency/GetSefer', 'GET', params, true));

    }

    const downloadPDF = async (info) => {
        setRideId(info.UetdsRideId);
        var params = {
            SeferUid: info.UetdsRideId
        }
        setDetail(await ApiCall('KKKaptan/agency/GetVoyageDetail', 'GET', params, true));
    }

    useEffect(() => {
        async function data() {
            if (detail) {
                const linkSource = `data:application/pdf;base64,${detail.SonucPdf}`;
                const downloadLink = document.createElement("a");
                const fileName = rideId + ".pdf";
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                setDetail(null);
            }
        }
        data();
    }, [detail]);

    return (
        <div className="container">
            <Header />
            <>
                <div className="row">
                    <div className="col-md-12 textCenter">
                        <h3>
                            Yolcu Listesi
                        </h3>
                    </div>
                </div>
                <div>
                    <div className="row">
                        <div className="col-md-3">
                            <Autocomplete
                                id="departure"
                                clearText="Temizle"
                                onChange={(event, value) => setDeparture(value)}
                                options={stations.data}
                                getOptionLabel={(option) => option.DurakAdi}
                                noOptionsText='Kalkış Yeri Bulunamadı'
                                // className="mb10 mt10"
                                style={{ width: '100%', fontSize: 14 }}
                                renderInput={(params) => <TextField {...params} label={"Kalkış Yeri"} variant="outlined" />}
                            />
                        </div>
                        <div className="col-md-3">
                            <Autocomplete
                                id="arrival"
                                clearText="Temizle"
                                onChange={(event, value) => setArrival(value)}
                                options={stations.data}
                                getOptionLabel={(option) => option.DurakAdi}
                                noOptionsText='Varış Yeri Bulunamadı'
                                // className="mb10 mt10"
                                style={{ width: '100%', fontSize: 14 }}
                                renderInput={(params) => <TextField {...params} label={"Varış Yeri"} variant="outlined" />}
                            />
                        </div>

                        <div className="col-md-2">
                            <DatePicker
                                // dateFormat="dd.MM.yyyy"
                                // minDate={subDays(new Date(), 7)}
                                locale="tr"
                                className="form-control w100 h100"
                                selected={date}
                                onChange={(e) => setDate(e)}>
                            </DatePicker>
                        </div>

                        <div className="col-md-2">
                            <TextField value={plate} onChange={(e) => setPlate(e.target.value)} label="Plaka" variant="outlined" />
                        </div>


                        <div className="col-md-2">
                            <Button variant="contained" onClick={() => getVoyageList()} className="w100 h100 fr" style={{ 'textTransform': 'none' }} color="primary">LİSTELE</Button>
                        </div>

                    </div>
                </div>
            </>
            <hr />
            <p>

                Bu uygulamadaki veriler <b>Flixbus tarafından UETDS'ye iletilen verilerdir</b>, görünmeyen seferler veya pdf içerisindeki hatalı eksik veriler için <b>KAMİLKOÇ BİLGİ TEKNOLOJİLERİNİ ARAMAYINIZ</b>.
            </p>
            <hr />
            {
                list && list.data &&
                <>
                    <div className="row">
                        <div className="col-md-12 textCenter">
                            <h3>
                                Yolcu Listesi Dökümü
                            </h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">
                            <b>
                                UEDTS RideId
                            </b>
                        </div>
                        <div className="col-md-4">
                            <b>
                                Ride UUID
                            </b>
                        </div>
                        <div className="col-md-2">
                            <b>
                                Plaka
                            </b>
                        </div>
                        <div className="col-md-4">
                            <b>
                                Sefer
                            </b>
                        </div>
                    </div>
                </>
            }

            {
                list && list.data && list.data.map((info, index) =>
                    <div className={`row ${index % 2 === 0 ? 'evenRow' : 'oddRow'}`} key={index}>
                        <div className="col-md-2">
                            <a href="#" onClick={() => downloadPDF(info)}>
                                {info.UetdsRideId}
                            </a>
                        </div>
                        <div className="col-md-4">
                            {info.RideUuid}
                        </div>
                        <div className="col-md-2">
                            {info.Plate}
                        </div>
                        <div className="col-md-4">
                            {info.VoyageName}
                        </div>
                    </div>
                )
            }

            {
                list && list.data && list.data.length === 0 &&
                <h3>
                    {list.message}
                </h3>
            }
            <hr />
        </div>
    );
}

export default PassengerList;